const minProgram = /miniProgram/i;

const isMiniProgramUserAgent = (req: any = null) => {
  let ua = req;
  if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string") return false;

  const result = minProgram.test(ua);

  return !!result;
};

export default isMiniProgramUserAgent;
